import React from "react";
import { Input } from "reactstrap";
import { PAYMENT_STATUS_OPTIONS } from "../utils/paymentStatus";

const ClientFilterBar = ({
  searchValue,
  onSearchChange,
  paymentStatus,
  onPaymentStatusChange,
  phase,
  onPhaseChange,
  linked,
  onLinkedChange,
  phases,
  hasAnyFilter,
  onClear,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 p-3 border-bottom">
      <Input
        type="text"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search name, email, phone, SSN or CUI"
        style={{ flex: "1 1 240px", minWidth: 0 }}
      />
      <Input
        type="select"
        value={paymentStatus}
        onChange={(e) => onPaymentStatusChange(e.target.value)}
        style={{ flex: "0 1 168px" }}
      >
        {PAYMENT_STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Input>
      <Input
        type="select"
        value={phase}
        onChange={(e) => onPhaseChange(e.target.value)}
        style={{ flex: "0 1 158px" }}
      >
        <option value="">All phases</option>
        {(phases || []).map((p) => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </Input>
      <Input
        type="select"
        value={linked ? "linked" : ""}
        onChange={(e) => onLinkedChange(e.target.value === "linked")}
        style={{ flex: "0 1 168px" }}
      >
        <option value="">All clients</option>
        <option value="linked">Has linked client</option>
      </Input>
      {hasAnyFilter && (
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={onClear}
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default ClientFilterBar;
